import {Component, computed, inject, input} from '@angular/core';
import {
  CardBodyComponent,
  CardComponent,
  OpportunityMatchCardComponent,
  OpportunityShape,
  StateMessageComponent
} from "@groundworks/ngx-groundworks-ui";
import {OPPORTUNITY_FUNNEL_PHASES} from '../../constants/opportunity-funnel.constants';
import {OpportunityInfo} from '../../sdk/sdk';
import {AddressNavigationService} from '../../services/address-navigation.service';

export function toOpportunityShape(
  opportunity: OpportunityInfo
): OpportunityShape {
  return {
    opportunityId: opportunity.id,
    opportunityCreatedDate: opportunity.createdAt?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) ?? null,
    opportunityPhase: {
      name: opportunity.phase?.name,
    },
    contacts:
      opportunity.contacts?.map((contact) => ({
        contactId: contact.id,
        contactFullName: contact.firstName + ' ' + contact.lastName,
        contactPhoneNumber: contact.phone,
        contactEmail: contact.email,
      })) ?? [],
    address: opportunity.address
      ? {
        fullAddress: opportunity.address.streetAddress + ', ' + opportunity.address.city + ', ' + opportunity.address.state + ' ' + opportunity.address.postalCode,
      }
      : undefined,
  };
}

@Component({
  selector: 'app-selected-opportunity',
  imports: [
    CardBodyComponent,
    CardComponent,
    OpportunityMatchCardComponent,
    StateMessageComponent
  ],
  templateUrl: './selected-opportunity.component.html',
})
export class SelectedOpportunityComponent {
  private readonly addressNavigationService = inject(AddressNavigationService);
  opportunity = input<OpportunityInfo | undefined>(undefined);
  readonly isLoadingInput = input<boolean>(false);
  readonly hasErrorInput = input<boolean>(false);

  readonly state = computed(() => {
    if (this.isLoadingInput()) {
      return 'loading';
    }
    if (this.hasErrorInput()) {
      return 'error';
    }
    if (!this.opportunity()) {
      return 'no-matches';
    }
    return 'matches';
  });

  funnelPhases = OPPORTUNITY_FUNNEL_PHASES;

  toOpportunityShape = (opportunity: OpportunityInfo) => {
    return toOpportunityShape(opportunity);
  }

  getState(): string {
    return this.state();
  }

  onDeselect() {
    window.close();
  }

  onAddressClick() {
    this.addressNavigationService.openInHomepage(this.opportunity()?.address);
  }
}
